// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0dc21578] .intl-phone-input{width:auto!important}[data-v-0dc21578] .intl-phone-input.allow-dropdown .country-list{white-space:normal;max-height:70px}.explanation[data-v-0dc21578]{font-size:16px}", ""]);
// Exports
module.exports = exports;
